import translate from '../../common/localization/translate';

export default function localeText() {
  return {
    selectAll: translate('javascript.TX_SELECTALL'),
    searchOoo: translate('common.SEARCH_PLACEHOLDER'),
    noRowsToShow: translate('evaluation.NO_DATA_AVAILABLE'),
  };
}
